import { Logo } from "@/components/brand/Logo";

export default function PublicFooter() {
  return (
    <footer className="bg-[#3E5641] text-white" data-testid="public-footer">
      <div className="container-x grid gap-10 py-16 md:grid-cols-4">
        <div className="md:col-span-2">
          <Logo variant="light" />
          <p className="mt-4 max-w-md text-sm text-white/70">
            Sistema de gestión y certificación vehicular. Autos revisados en cuatro etapas antes de exhibirse — no somos un catálogo sin revisar.
          </p>
        </div>
        <div>
          <p className="mb-3 text-xs uppercase tracking-widest text-white/50">Contacto</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li className="mono" data-testid="footer-whatsapp">WhatsApp: 999 998 0648</li>
            <li>Horario: Lunes a domingo, solo con cita</li>
            <li>Ciudad: Mérida</li>
          </ul>
        </div>
        <div>
          <p className="mb-3 text-xs uppercase tracking-widest text-white/50">Menú</p>
          <ul className="space-y-2 text-sm text-white/80">
            <li><a href="/#proceso" className="hover:text-[#D6866B]">Cómo funciona</a></li>
            <li><a href="/#vender" className="hover:text-[#D6866B]">Vender mi auto</a></li>
            <li><a href="/#comprar" className="hover:text-[#D6866B]">Comprar un auto</a></li>
            <li><a href="/#afiliados" className="hover:text-[#D6866B]">Vende con Dupla Automotriz</a></li>
            <li><a href="/admin/login" className="hover:text-[#D6866B]" data-testid="footer-admin-link">Acceso</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-x flex flex-col items-start justify-between gap-2 py-6 text-xs text-white/50 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} La Dupla Automotriz. Todos los derechos reservados.</span>
          <span className="mono">v1.0</span>
        </div>
      </div>
    </footer>
  );
}
